import { render, staticRenderFns } from "./EmailPreview.vue?vue&type=template&id=080dba6a&scoped=true&"
import script from "./EmailPreview.vue?vue&type=script&lang=ts&"
export * from "./EmailPreview.vue?vue&type=script&lang=ts&"
import style0 from "./EmailPreview.vue?vue&type=style&index=0&id=080dba6a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080dba6a",
  null
  
)

export default component.exports